import {
  IAddressSchema,
  IContactRequestSchema,
  IContactRespSchema,
  QuoteShareContact,
  QuoteShareContactRequiredAddress,
  SharedDealRoomContact,
} from '@monetize/types/app';
import { Maybe } from '@monetize/types/common';
import { nullifyEmptyStrings } from './misc';

/**
 * Compare two contacts to see if they are the same
 * This does not include every field, such as status, but includes all user-editable fields
 */
export function areContactsSame(
  existingContact?: Maybe<IContactRespSchema>,
  newContact?: Maybe<
    | IContactRequestSchema
    | QuoteShareContact
    | QuoteShareContactRequiredAddress
    | SharedDealRoomContact
  >,
): boolean {
  if (existingContact === newContact || (!existingContact && !newContact)) {
    return true;
  }

  if (!existingContact || !newContact) {
    return false;
  }

  // This sets null and trims strings to ensure comparison is accurate
  existingContact = existingContact
    ? nullifyEmptyStrings(existingContact)
    : existingContact;

  newContact = newContact ? nullifyEmptyStrings(newContact) : newContact;

  if (
    existingContact.fullName !== newContact.fullName ||
    existingContact.email !== newContact.email ||
    existingContact.phone !== newContact.phone
  ) {
    return false;
  }

  return areAddressesSame(existingContact.address, newContact.address);
}

export function areAddressesSame(
  address: Maybe<IAddressSchema>,
  newAddress: Maybe<IAddressSchema>,
): boolean {
  if (address === newAddress || (!address && !newAddress)) {
    return true;
  }

  if (!address || !newAddress) {
    return false;
  }

  address = nullifyEmptyStrings(address);
  newAddress = nullifyEmptyStrings(newAddress);

  return (
    address.line1 === newAddress.line1 &&
    address.line2 === newAddress.line2 &&
    address.city === newAddress.city &&
    address.state === newAddress.state &&
    address.postalCode === newAddress.postalCode &&
    address.country === newAddress.country
  );
}
